import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentCategoryType } from './normalize';

export const fetchShipmentCategoryType = createProvider(api.fetchShipmentCategoryType)
  .andThen((res) => normalizeShipmentCategoryType(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
